export enum ButtonTypes {
	submit = 'submit',
	button = 'button',
	reset = 'reset',
}
